// extracted by mini-css-extract-plugin
export default {"breadCrumbItem":"BreadCrumbItem_breadCrumbItem__DhDRb","hover":"BreadCrumbItem_hover__rHzYZ","labelWrapper":"BreadCrumbItem_labelWrapper__aVpDf"};